export default __webpack_public_path__ + "bcba_dashboar_empty_section.png";